export const USER_SETTING_EVENT_NOTIFICATIONS = 'eventNotifications';
export const USER_SETTING_PREVIEW_FEATURES = 'previewFeaturesEnabled';
export const USER_SETTING_CHART_PREFERENCES = 'chartPreferences';
export const USER_SETTING_SEMI_LIVE_CANDLES = 'semiLiveCandlesEnabled';
